import React from 'react';
import { ShortPortal } from "../typings";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { MdOutlineMoreVert } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ApiContextType } from "../api-context";

interface Props {
    api: ApiContextType;
    portal: ShortPortal;
}

function PortalRow(props: Props) {
    const navigate = useNavigate();

    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '12px 16px',
            width: '100%',
            alignItems: 'center'
        }}>
            <div className="drill-row-item" style={{flex: 2}}>{props.portal.id}</div>
            <div className="drill-row-item" style={{flex: 2}}>{props.portal.name}</div>
            <div className="drill-row-item" style={{flex: 2}}>{props.portal.type}</div>
            <div className="drill-row-item" style={{flex: 2}}>{props.portal.federationName}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.portal.expiresAt?.split(' ')[0]}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.portal.createdAt?.split(' ')[0]}</div>
            <Menu>
                <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                <MenuItems
                    className="menu-box"
                    anchor="bottom"
                >
                    <MenuItem>
                        <div className="menu-item" onClick={() => navigate(`/portal/${props.portal.id}`)}>
                            Edit
                        </div>
                    </MenuItem>
                </MenuItems>
            </Menu>
        </div>
    );
}

export default PortalRow;
